import classNames from 'classnames'
import { useField } from 'formik'

import { IconAlert } from '@/components/Icons'

type Props = {
  label: string
  description?: string
  name: string
  value: string | number
}

const Radio: React.FC<React.PropsWithChildren<Props>> = ({ label, description, ...props }) => {
  const [field, { touched, error }] = useField(props)
  const hasError = touched && error && typeof error === 'string'

  return (
    <>
      <div
        className={classNames(
          'rounded-xl bg-white ring',
          field.value === props.value ? 'ring-purple-base' : 'hover:border-grey-light',
        )}
      >
        <label className="flex cursor-pointer items-center p-5">
          <input
            checked={field.value === props.value}
            {...field}
            className="h-5 w-5 accent-purple-base"
            type="radio"
            value={props.value}
          />

          <div className="ml-5">
            <div className="font-medium">{label}</div>
            {description ? <div className="text-grey-base">{description}</div> : null}
          </div>
        </label>
      </div>

      {hasError ? (
        <div className="mt-3 flex items-center text-red-base text-sm">
          <IconAlert className="fill-current icon-xs mr-1 inline-block text-red-base" />
          {error}
        </div>
      ) : null}
    </>
  )
}

export default Radio
